import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CourseFinder from "./pages/CourseFinder";
import Services from "./pages/Services";
import LanguagePrep from "./pages/LanguagePrep";
import PersonalisedGuidence from "./pages/learn-more/PersonalisedGuidence";
import EndtoEndAppService from "./pages/learn-more/EndtoEndAppService";
import CreativeProtfolioGuidance from "./pages/learn-more/CreativeProtfolioGuidance";
import MedicalSchoolSupport from "./pages/learn-more/MedicalSchoolSupport";
import PHDApplicationMentorship from "./pages/learn-more/PHDApplicationMentorship";
import UniversityPreparation from "./pages/learn-more/UniversityPreparation";
import VisaAssitance from "./pages/learn-more/VisaAssistance";
import AboutUs from "./pages/AboutUs";
import PasswordEnglishLanguageTest from "./pages/language-learn-more/PasswordEnglishLanguageTest";
import LanguageCert from "./pages/language-learn-more/LanguageCert";
import Toefl from "./pages/language-learn-more/TOEFL";
import Doulingo from "./pages/language-learn-more/Duolingo";
import PTE from "./pages/language-learn-more/PTE";
import IELTS from "./pages/language-learn-more/IELTS";
import Home from "./pages/Home";
import "./App.css";
import ScrollToTop from "./pages/ScrollToTop";
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <div className="min-h-screen">
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<CourseFinder />} />
          <Route path="/services" element={<Services />} />
          <Route path="/language-prep" element={<LanguagePrep />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/personalised-guidence/:id"
            element={<PersonalisedGuidence />}
          />
          <Route
            path="/end-to-end-app-service/:id"
            element={<EndtoEndAppService />}
          />
          <Route
            path="/creative-portfolio-guidance/:id"
            element={<CreativeProtfolioGuidance />}
          />
          <Route
            path="/medical-school-support/:id"
            element={<MedicalSchoolSupport />}
          />
          <Route
            path="/phd-application-mentorship/:id"
            element={<PHDApplicationMentorship />}
          />
          <Route
            path="/university-preparation/:id"
            element={<UniversityPreparation />}
          />
          <Route path="/visa-assistance/:id" element={<VisaAssitance />} />
          <Route
            path="/password-english-language-test"
            element={<PasswordEnglishLanguageTest />}
          />
          <Route path="/language-cert" element={<LanguageCert />} />
          <Route path="/toefl" element={<Toefl />} />
          <Route path="/doulingo" element={<Doulingo />} />
          <Route path="/pte" element={<PTE />} />
          <Route path="/ielts" element={<IELTS />} />
          {/* You can add /about and /contact routes similarly */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
